import React from 'react';
import { LucideIcon } from '../../components/LucideIcon';
import type { IconVariant } from '@skin-seoul/service';

interface CheckIconProps {
  achieved: boolean;
  /** Icon variant - 'check' shows checkmark (24px), 'dot' shows small circle (12px) */
  variant?: IconVariant;
}

export function CheckIcon({ achieved, variant = 'check' }: CheckIconProps) {
  const bgColor = achieved ? 'bg-success-600' : 'bg-neutral-600';

  if (variant === 'dot') {
    return <div className={`w-3 h-3 ${bgColor} rounded-[6px]`} />;
  }

  return (
    <div className={`w-6 h-6 ${bgColor} flex items-center rounded-[12px] justify-center`}>
      <LucideIcon name="Check" strokeWidth={2.4} className="text-generic-0" size={16} />
    </div>
  );
}
